import React from 'react'

import i18n from 'i18next'

import Icon from '@components/icon/Icon'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

import { SlideViewMode } from './slide-view'

type SlideViewToggleProps = {
  viewMode: SlideViewMode
  onChange: (mode: SlideViewMode) => void
}

const SlideViewToggle = ({ viewMode, onChange }: SlideViewToggleProps) => (
  <TooltipProvider delayDuration={200}>
    <div
      className="slides-view-toggle"
      role="group"
      aria-label={i18n.t('editor.left-panel.slides.view-mode')}
    >
      <span
        className={`slides-view-toggle-thumb ${
          viewMode === 'names' ? 'slides-view-toggle-thumb-names' : ''
        }`}
      />
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className={`slides-view-toggle-button ${
              viewMode === 'thumbnails' ? 'slides-view-toggle-button-active' : ''
            }`}
            aria-pressed={viewMode === 'thumbnails'}
            aria-label={i18n.t('editor.left-panel.slides.view-thumbnails')}
            onClick={() => onChange('thumbnails')}
          >
            <Icon name="th-list" size={0.8} />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top">
          {i18n.t('editor.left-panel.slides.view-thumbnails')}
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className={`slides-view-toggle-button ${
              viewMode === 'names' ? 'slides-view-toggle-button-active' : ''
            }`}
            aria-pressed={viewMode === 'names'}
            aria-label={i18n.t('editor.left-panel.slides.view-names')}
            onClick={() => onChange('names')}
          >
            <Icon name="list" size={0.8} />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top">{i18n.t('editor.left-panel.slides.view-names')}</TooltipContent>
      </Tooltip>
    </div>
  </TooltipProvider>
)

export default SlideViewToggle
